import {
  useIsAuthenticated as useMsalIsAuthenticated,
  useMsal,
} from "@azure/msal-react";
import { useAuth0 } from "react-auth0-spa";

export interface CurrentUser {
  name: string;
  email: string;
  roleLabel: string;
}

// Providers sign in with MSAL (Azure AD); caregivers sign in with Auth0.
export const useCurrentUser = () => {
  const {
    user: auth0User,
    logout: auth0Logout,
    isAuthenticated: auth0Authenticated,
  } = useAuth0();
  const msalIsAuthenticated = useMsalIsAuthenticated();
  const { instance } = useMsal();
  const activeAccount = msalIsAuthenticated ? instance.getActiveAccount() : null;

  let user: CurrentUser | null = null;
  if (activeAccount) {
    user = {
      name: activeAccount.name || activeAccount.username || "User",
      email: activeAccount.username || "",
      roleLabel: "Provider",
    };
  } else if (auth0Authenticated && auth0User) {
    user = {
      name: auth0User.name || auth0User.nickname || auth0User.email || "User",
      email: auth0User.email || "",
      roleLabel: "Caregiver",
    };
  }

  const logout = async (): Promise<void> => {
    if (activeAccount) {
      try {
        instance.setActiveAccount(null);
        await instance.logoutRedirect({ account: activeAccount });
      } catch (error) {
        console.error("MSAL logout error:", error);
      }
    } else if (auth0Authenticated) {
      auth0Logout();
    }
  };

  return { user, logout };
};

export const getInitials = (name?: string): string => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};
